export function centsToDollar(cents: number) {
  let data = '';
  if (cents % 100 < 10) {
    data = String(Math.floor(cents / 100) + `.0${cents % 100}`);
  } else {
    data = String(Math.floor(cents / 100) + `.` + (cents % 100));
  }
  const finalData = data.replace(/\d(?=(\d{3})+\.)/g, '$&,');
  // finalData = finalData.replace(/\.00$/, "");
  return `$${finalData}`;
}

export const absCentsToDollar = (amount?: number) => centsToDollar(Math.abs(amount || 0));
